export default function SocialProof() {
  const sponsors = [
    { name: 'Butcher Block Social BBQ & Taphouse', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/5c73b7a5a2fd552ae5a839f81075ca67.jpeg' },
    { name: 'MEF Fieldhouse', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/66d3e9907cab4ce39d5ab08abfe1c7f4.png' },
    { name: 'Bradford White Corporation', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/1219a293fcc543ef2fad86bd1bdf8686.png' },
    { name: 'Dave Smith - State Farm Insurance', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/85063aef72d5e173a2439ebeb49bc711.png' },
    { name: 'Godwin Hardware & Plumbing', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/56a4f84b3528c8479f904b88f9d77a16.png' },
    { name: 'Steensma Accounting & Payroll', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/97d212970703531b557918d00d0a09ed.jpeg' },
    { name: 'SE Agricultural & Commercial Solutions', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/d9d3f6b891ac55d97a0f13475a6f6d39.png' },
    { name: 'SpartanNash', logo: null, image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/2e1a56fdc5a8e25a77e4f24f140fa642.png' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Local Businesses <span className="text-yellow-600">Already Supporting</span> CYFA
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto font-medium">
            Join these community leaders in supporting youth athletics
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {sponsors.map((sponsor, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-4 flex flex-col items-center justify-center hover:shadow-lg transition-all duration-300 border-2 border-gray-200"
            >
              <div className="w-full h-40 flex items-center justify-center mb-3">
                {sponsor.image ? (
                  <img
                    src={sponsor.image}
                    alt={sponsor.name}
                    className="max-w-full max-h-full object-contain"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                ) : (
                  <div className="w-20 h-20 flex items-center justify-center bg-purple-100 rounded-full">
                    <i className={`${sponsor.logo} text-4xl text-purple-700`}></i>
                  </div>
                )}
              </div>
              <p className="text-gray-600 font-bold text-center text-sm">{sponsor.name}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-2xl text-gray-700 font-bold">
            Your business could be featured here
          </p>
        </div>
      </div>
    </section>
  );
}